<div class="td-wb-w8ben-form-us-tin">
  <div class="td-wb-w8ben-form-us-tin__header">
    <span [attr.id]="getModalId()"
          translate="tdWb.w8BenForm.modal.usTin.TITLE"></span>
  </div>
  <div class="td-wb-w8ben-form-us-tin__description">
    <div translate="tdWb.w8BenForm.modal.usTin.DESCRIPTION_I"></div>
    <div translate="tdWb.w8BenForm.modal.usTin.DESCRIPTION_II"></div>
  </div>

  @if (!submitError) {
  <td-wb-form (submitAction)="onClickContinue()" autocomplete="off">
    <td-wb-form-row class="td-wb-w8ben-form-us-tin__form-row">
      <td-wb-input-group class="td-wb-w8ben-form-us-tin__form-input-group">
        <td-wb-input-group-label class="td-wb-w8ben-form-us-tin__form-label">
          <label for="td-wb-w8ben-form-us-tin">
            <span translate="tdWb.w8BenForm.modal.usTin.LABEL"></span>
            <td-wb-w8ben-tooltip>
              <span translate="tdWb.w8BenForm.modal.usTin.TOOLTIP"></span>
            </td-wb-w8ben-tooltip>
          </label>
        </td-wb-input-group-label>
        <td-wb-input-group-field class="td-wb-w8ben-form-us-tin__form-input-group-field">
          <input id="td-wb-w8ben-form-us-tin"
                 type="text"
                 name="taxResidency"
                 minlength="9"
                 maxlength="9"
                 tdWbInput
                 [pattern]="allowableTinCharactersRegex"
                 [(ngModel)]="tin"
                 (click)="onClickTinInput()">
          <td-wb-input-errors errorKeyNamespace="tdWb.w8BenForm.modal.usTin.tinErrors"
                              [errorKeyDisplayBeforeSubmit]="['pattern']" />
        </td-wb-input-group-field>
      </td-wb-input-group>
    </td-wb-form-row>

    <div class="td-wb-w8ben-form-us-tin__action">
      <td-wb-divider />
      <div class="td-wb-w8ben-form-us-tin__action-buttons">
        <button id="td-wb-w8ben-form-us-tin-back-button"
                tdWbButton
                tdWbButtonType="secondary"
                tdWbHref="modal.w8ben.tax_residency_benefits"
                [tdWbHrefParams]="{ hasUpdates: hasUpdates}"
                (click)="onClickBack()">
          <span translate="tdWb.w8BenForm.modal.usTin.BACK_BUTTON"></span>
        </button>
        <button tdWbButton
                type="submit"
                [disabled]="continueDisabled()">
          <span translate="tdWb.w8BenForm.modal.usTin.CONTINUE_BUTTON"></span>
        </button>
      </div>
    </div>
  </td-wb-form>
  } @else {
    <td-wb-w8ben-form-error [submitError]="true" />
  }
</div>
